<template>
  <!-- 组件管理组件库 -->
  <div class="componenManagement">
    <!-- 拖拽 -->
    <vuedraggable v-model="data" v-bind="dragOptions">
      <transition-group>
        <div
          v-for="(item, ind) in data"
          :key="item.text + ind"
          :class="item.text == '底部导航' ? 'item delDragitem' : 'item'"
        >
          <div v-if="item.component !== 'tabbar'" style="display: flex;justify-content: space-between;line-height: 40px;">
            <p>
              <i class="el-icon-s-grid" style="margin-right: 15px" />{{
                item.text
              }}
            </p>
            <div style="display: flex;  gap: 10px">
              <div v-if="item.isShow" style="width: 20px; height: 20px">
                <i
                  class="el-icon-view"
                  style="cursor: pointer; padding-right: 15px"
                  @click="handleView(item, ind, false)"
                ></i>
              </div>
              <div v-if="!item.isShow" style="width: 20px; height: 20px">
                <i
                  class="iconfont icon-yanjing"
                  @click="handleView(item, ind, true)"
                ></i>
              </div>
              <el-popconfirm
                title="您确定要删除该组件吗?"
                icon="el-icon-warning"
                iconColor="red"
                @confirm="onConfirms(ind)"
              >
                <i
                  class="el-icon-delete-solid"
                  slot="reference"
                  style="cursor: pointer"
                />
              </el-popconfirm>
            </div>
          </div>
        </div>
      </transition-group>
    </vuedraggable>
  </div>
</template>

<script>
import vuedraggable from "vuedraggable"; //拖拽组件

export default {
  name: "MyModule",
  props: ["datas"],
  components: { vuedraggable },
  data() {
    return {
      data: this.datas,
      dragOptions: {
        animation: 200,
        // class是 delDragitem 禁止拖拽
        filter: ".delDragitem",
      },
      currentActive: true,
    };
  },
  methods: {
    // 眼睛
    handleView(item, ind) {
      console.log('眼睛点击了', item, ind,)
      return 
      item.isShow = !item.isShow;
      console.log(item, ind, this.datas);
    },
    /* 删除组件 */
    onConfirms(res) {
      this.data.splice(res, 1);
      this.$emit("componenmanagement", this.data);
    },
  },
  watch: {
    datas(newVal) {
      console.log(
        "MyModuleMyModuleMyModule子组件传递过来的datas-----------------------------------",
        newVal,
      );
      this.data = newVal;
    },

    data(newVal) {
      this.$emit("componenmanagement", newVal);
    },
  },
  computed: {},
};
</script>

<style scoped lang="scss">
/* 组件管理 */
.componenManagement {
  // position: absolute;
  left: 0;
  top: 0;
  padding: 0 10px;
  box-sizing: border-box;
  /* 标题 */
  h2 {
    padding: 24px 16px 24px 0;
    margin-bottom: 15px;
    border-bottom: 1px solid #f2f4f6;
    font-size: 18px;
    font-weight: 600;
    color: #323233;
  }

  /* 选项 */
  .item {
    height: 40px;
    padding: 0 10px;
    font-size: 14px;
    cursor: all-scroll;
    color: #323233;
    border-radius: 2px;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    // box-shadow: 0 0 4px 0 rgba(10, 42, 97, 0.2);
    margin-bottom: 10px;
    i {
      color: #999;
    }
  }
  .delDragitem {
    background-color: rgba(10, 42, 97, 0.2);
    cursor: no-drop;
  }
}
</style>
